import * as eventos from "../../assets/";

export const EventosImage = [
    {   
        id: 0,
        title: "Curso Doces Descobertas",
        information: " formando 40 mulheres em parceria com Instituto Imap e Debora Aleluia da doceria o 'Segredo de Luiza'",
        data: "15 e 16  de Março de 2023",
        image: {
            src: eventos.evento1,
            alt: "Evento que formou 40 mulheres",
            width: "400px",
            heigth: "400px"
        }
    },
    {
        id: 1,
        title: "Corrida Inclusiva 2022",
        information: "Corrida inclusiva 2022 - Circuito movimente sensações contagem",
        image: {
            src: eventos.evento2,
            alt: "Evento que formou 40 mulheres",
            width: "400px",
            heigth: "400px"
        }
    }
]